import React from "react"

export class QuantityInput extends React.Component {
  constructor(props) {
    super(props)

    this.positivePattern = new RegExp(this.props.allowDecimal ? /^\d*\.?\d*$/ : /^[0-9]+$/)
    this.clickDropdownItem = this.clickDropdownItem.bind(this)
  }

  handleChange(event) {
    let newval = event.target.value
    if (this.positivePattern.test(newval))
      newval = parseInt(newval)
    else
      newval = ''
    this.props.onChange(newval)
  }

  clickDropdownItem(event) {
    this.props.onChange(event.target.value)
  }

  renderOptions() {
    var options = []
    var min = this.props.minimum || 1
    var max = Math.min(this.props.maximum || 1000, this.props.minimum + 19)

    for (var i = min; i <= max; i++) {
      options.push(
        <button className='dropdown-item' value={i} onClick={this.clickDropdownItem} key={"option_" + i}>
          {i}
        </button>
      )
    }
    return options
  }

  render() {
    return (
      <div className='input-group flex-nowrap'>
        <input
          type='text'
          value={this.props.value}
          id={this.props.id || ""}
          name="quantity"
          autocomplete='off'
          className="form-control text-center px-1"
          style={{width: '40px'}}
          onChange={this.handleChange.bind(this)}
        />
        <div className='input-group-append dropdown'>
          <button className='dropdown-toggle btn border px-1' data-toggle='dropdown'></button>
          <div className='dropdown-menu'>
            { this.renderOptions() }
          </div>
        </div>
      </div>
    )
  }
}
